<template>
  <div class="admin-sidebar d-flex justify-content-center">
    <AdminMenuEntries />
  </div>
</template>

<script>
import AdminMenuEntries from './AdminMenuEntries';
export default {
  name: 'AdminSidebar',
  components: { AdminMenuEntries },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
.admin-sidebar {
  background-color: $greyLight;
  border-right: 1px solid #929292;
  box-shadow: 0 0 10px #929292;
}
.admin-logo {
  min-width: 100px;
}
</style>
